module.exports = __webpack_public_path__ + "img/logoNP.42451cf3.png";